import type { ModuleOverlayElementDefinition } from "./contract";
import { adsOverlayElements } from "./ads/overlay/element";
import { textBlockOverlayElement } from "./text_library/overlay/element";
import { chatVotingOverlayElements } from "./chat_voting/overlay/element";
import { belaboxOverlayElements } from "./belabox/overlay/element";
import { votekickOverlayElements } from "./votekick/overlay/element";
import { emoteSlotOverlayElements } from "./emote_slots/overlay/element";
import { quizOverlayElements } from "./quiz/overlay/element";

export interface RegisteredOverlayElement {
  moduleId: string;
  definition: ModuleOverlayElementDefinition;
}

export const MODULE_OVERLAY_ELEMENTS: readonly RegisteredOverlayElement[] = [
  ...chatVotingOverlayElements.map((definition) => ({ moduleId: "chat_voting", definition })),
  { moduleId: "text_library", definition: textBlockOverlayElement },
  ...belaboxOverlayElements.map((definition) => ({ moduleId: "belabox", definition })),
  ...adsOverlayElements.map((definition) => ({ moduleId: "ads", definition })),
  ...votekickOverlayElements.map((definition) => ({ moduleId: "votekick", definition })),
  ...emoteSlotOverlayElements.map((definition) => ({ moduleId: "emote_slots", definition })),
  ...quizOverlayElements.map((definition) => ({ moduleId: "quiz", definition })),
];

export const moduleOverlayElementKindForMessage = (messageType: string): string => {
  const declared = MODULE_OVERLAY_ELEMENTS.find(({ definition }) =>
    definition.mergeRealtimeStateOnModuleMessages?.includes(messageType) === true);
  return declared?.definition.kind ?? messageType.slice("modul.".length);
};

export const moduleOverlayMessageRequiresStateReload = (messageType: string): boolean =>
  MODULE_OVERLAY_ELEMENTS.some(({ moduleId, definition }) =>
    definition.reloadStateOnModuleMessages?.includes(messageType) === true ||
    (definition.reloadStateOnHostEvents !== undefined && messageType === `modul.${moduleId}.state_changed`),
  );

export const mergeModuleOverlayElementState = (
  elementKind: string,
  current: Readonly<Record<string, unknown>> | null,
  incoming: Readonly<Record<string, unknown>>,
): Readonly<Record<string, unknown>> => MODULE_OVERLAY_ELEMENTS.find(({ definition }) => definition.kind === elementKind)
  ?.definition.mergeRealtimeState?.(current, incoming) ?? incoming;

export const preserveModuleOverlayElementStateOnReload = (
  elementKind: string,
  previous: Readonly<Record<string, unknown>> | null,
  incoming: Readonly<Record<string, unknown>> | null,
): Readonly<Record<string, unknown>> | null | undefined => {
  const definition = MODULE_OVERLAY_ELEMENTS.find(({ definition: candidate }) => candidate.kind === elementKind)?.definition;
  if (definition?.preserveRealtimeStateOnReload !== true || previous === null) return undefined;
  if (incoming === null) return previous;
  return definition.mergeRealtimeState?.(previous, incoming) ?? incoming;
};
